module.exports = __webpack_public_path__ + "static/assets/7e13680b333771c3b41440bb715d0972.svg";